/**
 * manager-groups-mobile.js
 */

import React from 'react';
import { useHistory } from 'react-router-dom';
import GroupCardMobile from '../group-card-mobile';
import { ManagerGroupsContext } from './manager-groups-context';
import { managerGroupsRoute } from './manager-groups';


export default function ManagerGroupsMobile(props) {
  const { managers } = React.useContext(ManagerGroupsContext);
  const history = useHistory();
  
  return (
    <GroupCardMobile
      iconType='group-manager'
      title='Managers'
      count={managers.length}
      route={managerGroupsRoute(history)}
      description='All supervisors and trainers that have access to your account.'
    />
  );
}